export default {
  "content": "<rect width=\"40\" height=\"40\" rx=\"6\" fill=\"#E5F0FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.42 10a3.013 3.013 0 00-2.836 1.991l-.604 1.69a5 5 0 01-3.983 3.266A1.03 1.03 0 0013.97 16h-2.94A1.03 1.03 0 0010 17.03v11.94c0 .569.461 1.03 1.03 1.03h2.94A1.03 1.03 0 0015 28.97v-.14A9 9 0 0019.438 30h3.743a6 6 0 005.789-4.421l1.306-4.79A3 3 0 0027.38 17h-2.85l.818-3.272c.477-1.907-.991-3.728-2.93-3.728zM13 18h-1v10h1V18zm8.468-5.336c.14-.393.523-.664.952-.664.664 0 1.143.624.989 1.242l-1.13 4.515A1 1 0 0023.25 19h4.131a1 1 0 01.965 1.263l-1.306 4.79A4 4 0 0123.181 28h-3.743a7 7 0 01-3.892-1.182L15 26.453v-7.49a7 7 0 005.864-4.609l.604-1.69z\" fill=\"#006AFF\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};